import { render, staticRenderFns } from "./InformationRequests.vue?vue&type=template&id=fb663cc2"
import script from "./InformationRequests.vue?vue&type=script&lang=js"
export * from "./InformationRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports